module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_8004.f9486b6c.png";